/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { CapHpiDvlaDTO } from '../models/CapHpiDvlaDTO';
import type { VideoLogCustomerTypes } from '../models/VideoLogCustomerTypes';
import type { VideoLogDto } from '../models/VideoLogDto';
import type { VideoLogDtoPagedListData } from '../models/VideoLogDtoPagedListData';
import type { VideoLogInput } from '../models/VideoLogInput';
import type { VideoLogRenderModel } from '../models/VideoLogRenderModel';
import type { VideoLogUserEmailDataModel } from '../models/VideoLogUserEmailDataModel';
import type { VideoNumberEnum } from '../models/VideoNumberEnum';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VideoLogService {

  /**
   * @param customerType
 *
 * 1 = Sales
 *
 * 2 = Service
 *
 * 3 = Template
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
   * @param userId 
   * @param from 
   * @param to 
   * @param enquiryCrmId 
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns VideoLogDtoPagedListData Success
   * @throws ApiError
   */
  public static getVideoLogs(
customerType?: VideoLogCustomerTypes,
branch?: BranchType,
userId?: Array<number>,
from?: string,
to?: string,
enquiryCrmId?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<VideoLogDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs',
      query: {
        'CustomerType': customerType,
        'Branch': branch,
        'UserId': userId,
        'From': from,
        'To': to,
        'EnquiryCrmId': enquiryCrmId,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postVideoLogs(
requestBody?: VideoLogInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns VideoLogDto Success
   * @throws ApiError
   */
  public static getVideoLogs1(
id: number,
): CancelablePromise<VideoLogDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVideoLogs(
id: number,
requestBody?: VideoLogInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/video-logs/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVideoLogs(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/video-logs/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsVideos(
id: number,
formData?: {
Video: Blob;
VideoNumber: VideoNumberEnum;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/{id}/videos',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param videoNumber
 *
 * 1 = FirstVideo
 *
 * 2 = SecondVideo
 *
 * 3 = ThirdVideo
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVideoLogsVideos(
id: number,
videoNumber: VideoNumberEnum,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/video-logs/{id}/videos/{videoNumber}',
      path: {
        'id': id,
        'videoNumber': videoNumber,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsYoutubeVideo(
id: number,
formData?: {
Video: Blob;
VideoNumber: VideoNumberEnum;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/{id}/youtube-video',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsRenderAsset(
requestBody?: VideoLogRenderModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/render-asset',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsEmailUserInfo(
requestBody?: VideoLogUserEmailDataModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/email-user-info',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsSendEmail(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/{id}/send-email',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsSendSms(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/{id}/send-sms',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param regNo 
   * @param stockNo 
   * @returns CapHpiDvlaDTO Success
   * @throws ApiError
   */
  public static getVideoLogsLookUpVehicle(
regNo?: string,
stockNo?: string,
): CancelablePromise<CapHpiDvlaDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs/look-up-vehicle',
      query: {
        'regNo': regNo,
        'stockNo': stockNo,
      },
    });
  }

}
